var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-logo" },
    [
      _c(
        "transition-group",
        { attrs: { name: "fade" } },
        [
          !_vm.keyCollapse
            ? [
                _c(
                  "el-row",
                  { key: "1", staticClass: "avue-logo-title" },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("img", {
                        staticClass: "avue-logo-image-2",
                        attrs: {
                          src: _vm.platformData.logos || "/svg/logo.svg",
                        },
                      }),
                    ]),
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("span", { staticClass: "logo-title" }, [
                        _vm._v(
                          _vm._s(
                            (_vm.platformData.title ||
                              _vm.$t("common.yinYeHealth")) +
                              "（" +
                              _vm.$t("common.projectPort") +
                              "）"
                          )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }